import { CalendarClock, Headphones, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { crmApi } from "./api";
import { leadStatus } from "./types";

export function SfaDashboardPage() {
  const leads = useQuery({ queryKey: ["crm-leads"], queryFn: crmApi.leads });
  const followUps = useQuery({ queryKey: ["crm-follow-ups"], queryFn: crmApi.followUps });
  const activeLeads = (leads.data ?? []).filter((lead) => !["Converted", "Not interested"].includes(leadStatus(lead)));
  const due = (followUps.data ?? []).filter((item) => !item.done && new Date(item.dueAt) <= new Date());
  const cards = [{ label: "Active leads", value: activeLeads.length, href: "/crm/leads", icon: Users }, { label: "Follow-ups due", value: due.length, href: "/crm/follow-ups", icon: CalendarClock }, { label: "Calling queue", value: activeLeads.filter((lead) => !!lead.phone).length, href: "/crm/dialer", icon: Headphones }];
  return (
    <div className="space-y-4 px-4 sm:px-5 md:px-6 pb-6 pt-3 sm:pt-4">
      <p className="font-mono text-xs font-semibold uppercase tracking-[0.16em] text-accent-700 dark:text-accent-400">Sales force automation</p>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-sm font-semibold text-ink">Today&apos;s sales workspace</h1>
          <p className="mt-1 text-sm text-ink-3">A focused view of the leads and conversations that need attention.</p>
        </div>
        <Link to="/crm/leads" className="rounded-lg bg-accent-500 px-4 py-2 text-sm font-semibold text-ink hover:bg-accent-600 transition-colors">Open leads</Link>
      </div>
      <section className="grid gap-3 sm:gap-4 md:grid-cols-3">
        {cards.map(({ label, value, href, icon: Icon }) => (
          <Link key={label} to={href} className="rounded-xl shadow-card dark:shadow-card-dark bg-paper-card dark:bg-[#292524] p-4 sm:p-5 transition-all hover:shadow-card-hover">
            <Icon className="h-5 w-5 text-accent-700 dark:text-accent-400" />
            <p className="mt-4 font-mono text-3xl font-bold text-ink">{value}</p>
            
          </Link>
        ))}
      </section>
      <section className="rounded-xl shadow-card dark:shadow-card-dark bg-paper-card dark:bg-[#292524] overflow-hidden">
        <div className="flex items-center justify-between border-b border-line px-5 py-4">
          <div>
            <h2 className="font-semibold text-ink">Priority follow-ups</h2>
            <p className="mt-0.5 text-xs text-ink-3">Due now or overdue.</p>
          </div>
          <Link to="/crm/follow-ups" className="text-xs font-semibold text-accent-700 dark:text-accent-400 hover:underline">Open queue</Link>
        </div>
        {due.length ? (
          <div className="divide-y divide-line">
            {due.slice(0, 6).map((item) => (
              <Link key={item.id} to={`/crm/leads/${item.leadId}`} className="flex items-center justify-between gap-4 px-5 py-3 hover:bg-soft transition-colors">
                <span className="min-w-0">
                  <span className="block truncate text-sm font-semibold text-ink">{item.name || item.phone || "Lead"}</span>
                  <span className="mt-0.5 block truncate text-xs text-ink-3">{item.note || "Follow up with this lead"}</span>
                </span>
                <span className="rounded-full bg-warning-soft px-2 py-0.5 text-[11px] font-semibold text-warning">Overdue</span>
              </Link>
            ))}
          </div>
        ) : (
          <p className="p-8 text-center text-sm text-ink-3">No follow-ups need attention right now.</p>
        )}
      </section>
    </div>
  );
}
